import React from 'react';

import { useStore } from '@/store';
import { formatDateTimeCompact } from '@/utils/date';

interface FormattedDateTimeProps {
  /** ISO date string to format */
  value: string | undefined;
  /** Optional className for the span */
  className?: string;
}

/**
 * Component that displays a formatted date/time in the user's selected timezone.
 * Renders a span element with the formatted date.
 * Automatically subscribes to timezone changes from the store.
 *
 * Output format: "Dec 25, 3:45 PM"
 */
export const FormattedDateTime: React.FC<FormattedDateTimeProps> = ({ value, className }) => {
  const { getTimeZone } = useStore();
  const timeZone = getTimeZone();
  return <span className={className}>{formatDateTimeCompact(value, timeZone)}</span>;
};
